$(document).ready(function() {
    $('a.shg-btn').click(function(event) {
        event.preventDefault(); // Prevent the default link behavior
        
        var href = $(this).attr('href');
        var url = new URL(href); // Create a URL object

        // Extract parameters from the URL
        var id = url.searchParams.get('id');
        var quantity = url.searchParams.get('quantity');
        var selling_plan = url.searchParams.get('selling_plan');

        if (selling_plan !== null) {
          console.log("Adding subscription");
          // Prepare data to be sent
          var postData = {
              id: id,
              quantity: quantity,
              selling_plan: selling_plan
          };
  
          // Post data using AJAX
          $.ajax({
              url: 'https://www.twc.health/cart/add', // Adjust if the URL needs to be dynamic
              type: 'POST',
              data: postData,
              success: function(response) {
                  // Redirect to the cart page on successful submission
                  window.location.href = '/cart';
              },
              error: function(xhr, status, error) {
                  // Handle errors here
                  console.error("Error submitting form: " + error);
              }
          });
        } else {
          window.location.href = href;
        }
        
        
    });
});
